'use client';

import { useMutation, useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useAuth } from 'react-oidc-context';

import { ApiManager, ProductNotification, useHistoryState } from '@zoomit/web-kit';

type Props = {
  productId: string;
};

export const usePriceNotify = (props: Props) => {
  const { productId } = props;

  const priceNotifyPopOverState = useHistoryState<boolean>({
    id: 'price-notify-modal',
    initialState: false,
  });

  const { user, isAuthenticated } = useAuth();

  const notifyQuery = useQuery(
    ['price-notify', productId],
    async () => {
      const res = await ApiManager.get(`${ProductNotification}/is-set`, {
        headers: { Authorization: `Bearer ${user?.access_token}` },
        params: { productId },
      });
      return res.data;
    },
    {
      enabled: isAuthenticated,
    },
  );

  const postMutation = useMutation({
    mutationFn: () => {
      return ApiManager.post(
        `${ProductNotification}`,
        { productId },
        {
          headers: { Authorization: `Bearer ${user?.access_token}` },
        },
      );
    },
    onSuccess: () => {
      toast.success(`اعلان قیمت برای این محصول فعال شد`);
      notifyQuery.refetch();
      priceNotifyPopOverState.close();
    },
  });

  const deleteMutation = useMutation({
    mutationFn: () => {
      return ApiManager.delete(`${ProductNotification}?productId=${productId}`, {
        headers: { Authorization: `Bearer ${user?.access_token} ` },
      });
    },
    onSuccess: (res) => {
      toast.error('اعلان قیمت این محصول غیر فعال شد');
      notifyQuery.refetch();
    },
  });
  return {
    deleteMutation,
    postMutation,
    priceNotifyPopOverState,
    notifyQuery,
  };
};
